/*example*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Prisma",
  "description": "学习如何在 Turborepo 中使用 Prisma。"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Prisma 凭借其直观的数据模型、自动迁移、类型安全和自动补齐功能，为开发者在使用数据库时带来全新的体验。"
  }, {
    "heading": "",
    "content": "¥Prisma unlocks a new level of developer experience when working with databases thanks to its intuitive data model, automated migrations, type-safety & auto-completion."
  }, {
    "heading": "",
    "content": "官方指南 描述了如何将 Prisma 集成到 Turborepo 中，包括："
  }, {
    "heading": "",
    "content": "¥Their official guide describes how to integrate Prisma into a Turborepo, including:"
  }, {
    "heading": "",
    "content": "Prisma 客户端初始化"
  }, {
    "heading": "",
    "content": "¥Prisma client initialization"
  }, {
    "heading": "",
    "content": "将客户端打包为 内部包"
  }, {
    "heading": "",
    "content": "¥Packaging the client as an Internal Package"
  }, {
    "heading": "",
    "content": "执行迁移"
  }, {
    "heading": "",
    "content": "¥Performing migrations"
  }, {
    "heading": "",
    "content": "在本地处理你的应用"
  }, {
    "heading": "",
    "content": "¥Working on your applications locally"
  }, {
    "heading": "",
    "content": "部署中"
  }, {
    "heading": "",
    "content": "¥Deploying"
  }, {
    "heading": "示例-example",
    "content": "¥Example"
  }, {
    "heading": "示例-example",
    "content": "要开始使用我们社区支持的 Prisma 示例，请运行："
  }, {
    "heading": "示例-example",
    "content": "¥To get started with our community-supported Prisma example, run:"
  }],
  "headings": [{
    "id": "示例-example",
    "content": "示例 /*example*/"
  }]
};
import {Tabs, Tab} from 'fumadocs-ui/components/tabs';
import {Callout} from '#components/callout';
import {Steps, Step} from '#components/steps';
import {CreateTurboCallout} from './create-turbo-callout.tsx';
export const toc = [{
  depth: 2,
  url: "#示例-example",
  title: _jsx(_Fragment, {
    children: "示例 "
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://www.prisma.io/",
        children: "Prisma"
      }), " 凭借其直观的数据模型、自动迁移、类型安全和自动补齐功能，为开发者在使用数据库时带来全新的体验。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsx(_components.a, {
        href: "https://www.prisma.io/",
        children: "Prisma"
      }), " unlocks a new level of developer experience when working with databases thanks to its intuitive data model, automated migrations, type-safety & auto-completion."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://prisma.nodejs.cn/guides/turborepo",
        children: "官方指南"
      }), " 描述了如何将 Prisma 集成到 Turborepo 中，包括："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsx(_components.a, {
        href: "https://prisma.nodejs.cn/guides/turborepo",
        children: "Their official guide"
      }), " describes how to integrate Prisma into a Turborepo, including:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "Prisma 客户端初始化"
        }), "\n", _jsx(_components.p, {
          children: "¥Prisma client initialization"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["将客户端打包为 ", _jsx(_components.a, {
            href: "/docs/core-concepts/internal-packages",
            children: "内部包"
          })]
        }), "\n", _jsxs(_components.p, {
          children: ["¥Packaging the client as an ", _jsx(_components.a, {
            href: "/docs/core-concepts/internal-packages",
            children: "Internal Package"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "执行迁移"
        }), "\n", _jsx(_components.p, {
          children: "¥Performing migrations"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "在本地处理你的应用"
        }), "\n", _jsx(_components.p, {
          children: "¥Working on your applications locally"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "部署中"
        }), "\n", _jsx(_components.p, {
          children: "¥Deploying"
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "示例-example",
      children: "示例 "
    }), "\n", _jsx(_components.p, {
      children: "¥Example"
    }), "\n", _jsx(_components.p, {
      children: "要开始使用我们社区支持的 Prisma 示例，请运行："
    }), "\n", _jsx(_components.p, {
      children: "¥To get started with our community-supported Prisma example, run:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "npx"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " create-turbo@latest"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " -e"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " with-prisma"
            })]
          })
        })
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
